export const SM_CONTENT = {
  hero: {
    kicker: 'Para empresas que precisam organizar vendas e clientes',
    title: 'Seu histórico de cliente está espalhado entre WhatsApp, planilha e memória. Isso custa vendas.',
    subtitle:
      'Centralize o cadastro de clientes com histórico de compras, acompanhe cada venda em um funil de status customizável e calcule a comissão de cada vendedor automaticamente.',
    cta: 'Quero organizar minhas vendas',
    ctaMessage: 'Quero conhecer o sistema de gestão de vendas do 77Gestão',
    urgency: 'Cada venda sem status claro é uma venda que pode travar sem ninguém perceber.',
  },

  statsStrip: [
    { number: '1 lugar', label: 'para todo o histórico do cliente', icon: 'fa-solid fa-user-clock' },
    { number: 'Customizável', label: 'funil de status de venda', icon: 'fa-solid fa-filter' },
    { number: 'Automática', label: 'comissão por vendedor', icon: 'fa-solid fa-hand-holding-dollar' },
  ],

  pain: {
    title: 'Reconhece essas situações na hora de vender e atender cliente?',
    intro:
      'Empresas que vendem para pessoas físicas ou jurídicas perdem oportunidades quando o histórico do cliente e o andamento da venda não estão organizados em um só lugar.',
    items: [
      { icon: 'fa-solid fa-comments', text: 'Histórico do cliente espalhado entre WhatsApp, e-mail, planilha e memória de quem atendeu da última vez.' },
      { icon: 'fa-solid fa-filter-circle-xmark', text: 'Ninguém sabe em que fase está cada venda — se já foi aprovada, se está esperando entrega ou parada há semanas.' },
      { icon: 'fa-solid fa-eye-slash', text: 'Vendedor sem visibilidade clara da própria carteira de clientes e propostas em aberto.' },
      { icon: 'fa-solid fa-hand-holding-dollar', text: 'Comissão de vendedor calculada na mão, no fim do mês, com discussão sobre quem vendeu o quê.' },
      { icon: 'fa-solid fa-route', text: 'Sem saber de onde vêm as vendas — se é indicação, catálogo, WhatsApp ou outro canal.' },
      { icon: 'fa-solid fa-file-circle-question', text: 'Proposta comercial feita em documento avulso, sem controle de quantas foram aceitas ou recusadas.' },
    ],
  },

  midCta: {
    text: 'E se cada cliente já mostrasse o histórico completo e cada venda já indicasse exatamente em que fase está?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de gestão de vendas do 77Gestão',
  },

  solution: {
    title: 'Cliente, venda e comissão organizados em um único sistema',
    intro:
      'O módulo de vendas e clientes do 77Gestão foi pensado para dar clareza a cada etapa, do primeiro contato até a comissão do vendedor.',
    cards: [
      {
        icon: 'fa-solid fa-address-book',
        title: 'Cadastro completo de cliente',
        text: 'Histórico de compras, propostas, documentos e situação de inadimplência de cada cliente PF ou PJ em um só lugar.',
      },
      {
        icon: 'fa-solid fa-file-signature',
        title: 'Propostas comerciais',
        text: 'Gere propostas em PDF, acompanhe a aprovação e transforme automaticamente em venda ou contrato.',
      },
      {
        icon: 'fa-solid fa-diagram-project',
        title: 'Funil de status customizável',
        text: 'Configure as fases da sua venda, do pedido à entrega, e veja exatamente onde cada uma está parada.',
      },
      {
        icon: 'fa-solid fa-route',
        title: 'Canais de negociação',
        text: 'Identifique de onde vêm suas vendas — indicação, catálogo, WhatsApp ou outro canal — e direcione esforço com base em dado real.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Comissão automática por vendedor',
        text: 'Configure a regra de comissão uma vez e o sistema calcula automaticamente a cada venda fechada.',
      },
      {
        icon: 'fa-solid fa-store',
        title: 'Catálogo público com pedido via WhatsApp',
        text: 'Compartilhe seu catálogo de produtos e receba pedidos direto pelo WhatsApp ou via proposta, sem depender de atendimento manual para toda consulta.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a venda para de depender da memória de alguém',
    intro:
      'Uma empresa com vários vendedores organizava clientes e vendas em planilhas paralelas, sem padrão entre a equipe e sem visibilidade do estágio de cada negociação.',
    stats: [
      { number: '100%', label: 'do histórico de cliente em um só lugar' },
      { number: '0', label: 'vendas perdidas de vista no meio do processo' },
      { number: 'Automática', label: 'apuração de comissão por vendedor' },
    ],
    paragraphs: [
      'Depois da implantação, cada cliente passou a ter um cadastro único com histórico de compras e propostas, acessível para qualquer vendedor da equipe.',
      'O funil de status, customizado para o processo da empresa, passou a mostrar exatamente onde cada venda estava parada — e a comissão de cada vendedor passou a ser calculada automaticamente, sem planilha à parte.',
    ],
    highlight: 'Resultado: histórico de cliente centralizado, vendas com status visível e comissão sem discussão no fim do mês.',
    cta: 'Quero esse mesmo controle',
    ctaMessage: 'Vi o resultado e quero entender como organizar minhas vendas e clientes no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão de vendas e clientes',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Histórico de cada cliente e status de cada venda disponíveis para toda a equipe, não só na cabeça de quem atendeu.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Funil de status customizado ao seu processo, do pedido à entrega, sem venda esquecida no meio do caminho.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Comissão sem discussão',
        text: 'Cada vendedor sabe exatamente quanto vendeu e quanto vai receber, calculado automaticamente pelo sistema.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para organizar vendas e clientes',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Funil de vendas e canais de negociação configuráveis para o seu processo comercial, não um modelo fechado.' },
      { icon: 'fa-solid fa-link', text: 'Cliente, proposta, venda, comissão e financeiro integrados — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada para sua equipe de vendas usar o sistema com segurança desde o início.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O sistema é um CRM com automação de marketing?',
        answer:
          'Não. O 77Gestão organiza o histórico de compras, propostas e o funil de vendas de cada cliente, mas não faz automação de marketing ou captação de leads — o foco é o controle comercial pós-contato.',
      },
      {
        question: 'Consigo personalizar as fases do funil de vendas?',
        answer:
          'Sim. Você configura o funil de status de acordo com o processo da sua empresa, do pedido até a entrega.',
      },
      {
        question: 'A comissão do vendedor é calculada automaticamente?',
        answer:
          'Sim. Você define a regra de comissão por vendedor e o sistema calcula automaticamente a cada venda fechada, sem cálculo manual no fim do mês.',
      },
      {
        question: 'Consigo saber de onde vêm minhas vendas?',
        answer:
          'Sim. O sistema permite cadastrar canais de negociação, para identificar se a venda veio de indicação, catálogo, WhatsApp ou outro canal.',
      },
      {
        question: 'O catálogo público processa pagamento online?',
        answer:
          'Não. O catálogo público mostra produtos e disponibilidade para o cliente, mas o pedido é enviado via WhatsApp ou vira uma proposta comercial — não há checkout de pagamento direto no catálogo.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de depender da memória para saber onde está cada venda.',
    subtitle:
      'Agende uma demonstração e veja como organizar clientes, propostas, funil de vendas e comissão em um único sistema.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de gestão de vendas do 77Gestão',
  },

  seo: {
    title: 'Sistema de Gestão de Vendas e Clientes | 77Gestão',
    description:
      'Sistema de gestão de vendas e clientes: histórico de compras, funil de status customizável, canais de negociação e comissão automática por vendedor.',
  },
};
